import React from 'react';

import { Box } from '@mafc/trolly';

import { IOffer } from 'network/response/ICart';
import { IPrice, getFormattedPrice, getWasPrice } from 'utils/price.util';
import * as S from './Prices.style';

const Prices: React.FC<{ offer?: IOffer; totalPrice: IPrice; isLoyaltyPrice: boolean }> = ({
  offer,
  totalPrice,
  isLoyaltyPrice,
}) => {
  const wasPrice = getWasPrice(offer ? offer.price : totalPrice);

  return (
    <Box>
      <S.Price isLoyaltyPrice={isLoyaltyPrice} data-testid="__cart_list_item_total_price__">
        {getFormattedPrice(totalPrice, false, true, true)}
      </S.Price>

      {wasPrice && <S.WasPrice as="del">{wasPrice}</S.WasPrice>}
    </Box>
  );
};

export default Prices;
